import { render } from "./Household.vue?vue&type=template&id=e351bab0&scoped=true"
import script from "./Household.vue?vue&type=script&lang=js"
export * from "./Household.vue?vue&type=script&lang=js"

import "./Household.vue?vue&type=style&index=0&id=e351bab0&scoped=true&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\52\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e351bab0"]])

export default __exports__